module.exports = __webpack_public_path__ + "static/img/bg_share_second.9afe53f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/riverMountain-3/bg_share_second.png
// module id = 6cgs
// module chunks = 1